import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/Purchase/verifyNewStockReceivedAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchVerifyNewStockReceivedQueue = createAsyncThunk(
    'verifyNewStockReceived/fetchQueue',
    async ({ roleId, userid }, { rejectWithValue }) => {
        try { return await api.getVerifyNewStockReceivedQueue(roleId, userid); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch verification queue')); }
    }
);

export const fetchViewNewStockReceivedGrid = createAsyncThunk(
    'verifyNewStockReceived/fetchItems',
    async (trno, { rejectWithValue }) => {
        try { return await api.getViewNewStockReceivedGrid(trno); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch item details')); }
    }
);

export const approveNewStockIssueRecieved = createAsyncThunk(
    'verifyNewStockReceived/approve',
    async (payload, { rejectWithValue }) => {
        try { return await api.approveNewStockIssueRecieved(payload); }
        catch (e) { return rejectWithValue(err(e, 'Failed to submit verification')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    items: [], itemsLoading: false, itemsError: null,
    verifyLoading: false, verifyError: null, verifyResult: null,
};

const verifyNewStockReceivedSlice = createSlice({
    name: 'verifyNewStockReceived',
    initialState,
    reducers: {
        clearNewStockReceivedItems: (s) => { s.items = []; s.itemsError = null; },
        clearNewStockReceivedVerifyResult: (s) => { s.verifyResult = null; s.verifyError = null; },
        resetVerifyNewStockReceived: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVerifyNewStockReceivedQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchVerifyNewStockReceivedQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchVerifyNewStockReceivedQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(fetchViewNewStockReceivedGrid.pending, (s) => { s.itemsLoading = true; s.itemsError = null; })
            .addCase(fetchViewNewStockReceivedGrid.fulfilled, (s, a) => { s.itemsLoading = false; s.items = a.payload?.Data || []; })
            .addCase(fetchViewNewStockReceivedGrid.rejected, (s, a) => { s.itemsLoading = false; s.itemsError = a.payload; s.items = []; });

        builder
            .addCase(approveNewStockIssueRecieved.pending, (s) => { s.verifyLoading = true; s.verifyError = null; })
            .addCase(approveNewStockIssueRecieved.fulfilled, (s, a) => { s.verifyLoading = false; s.verifyResult = a.payload?.Data ?? a.payload; })
            .addCase(approveNewStockIssueRecieved.rejected, (s, a) => { s.verifyLoading = false; s.verifyError = a.payload; });
    },
});

export const {
    clearNewStockReceivedItems, clearNewStockReceivedVerifyResult, resetVerifyNewStockReceived,
} = verifyNewStockReceivedSlice.actions;

export const selectVNSRQueue = (s) => s.verifyNewStockReceived.queue;
export const selectVNSRQueueLoading = (s) => s.verifyNewStockReceived.queueLoading;
export const selectVNSRQueueError = (s) => s.verifyNewStockReceived.queueError;
export const selectVNSRItems = (s) => s.verifyNewStockReceived.items;
export const selectVNSRItemsLoading = (s) => s.verifyNewStockReceived.itemsLoading;
export const selectVNSRVerifyLoading = (s) => s.verifyNewStockReceived.verifyLoading;

export default verifyNewStockReceivedSlice.reducer;
